import React from 'react';
import './ToggleOption.scss';

interface ToggleOptionProps {
  label: string;
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export default function ToggleOption({ label, enabled, onChange, disabled, className }: ToggleOptionProps) {
  return (
    <div className={`toggle-option ${disabled ? 'toggle-option--disabled' : ''} ${className || ''}`}>
      <button
        analytics-id={`toggle-option-btn-${label.replace(/\s+/g, '-').toLowerCase()}`}
        className={`toggle-switch ${enabled ? 'toggle-switch--active' : ''}`}
        onClick={() => !disabled && onChange(!enabled)} // Prevent onChange if disabled
        aria-checked={enabled}
        role='switch'
        aria-label={label}
        disabled={disabled} // Disable the button if disabled is true
      >
        <span className='toggle-switch__handle' />
      </button>
      <label className='toggle-option__label'>{label}</label>
    </div>
  );
}
